import { Stack, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { ReleaseSongFieldType } from 'services/store/distribution/types';
import AdvancedOptionsTextfield from './components';

type PropsType = {
  releaseId: string;
};

const AdvancedOptions = ({ releaseId }: PropsType) => {
  const { t } = useTranslation();

  return (
    <Stack gap={2}>
      <Typography sx={{ fontWeight: 500 }}>
        {t('distribution:tracklist:songs:metadata:advancedOptions')}
      </Typography>
      <AdvancedOptionsTextfield
        releaseId={releaseId}
        field={ReleaseSongFieldType.AdditionalArtists}
      />
      <AdvancedOptionsTextfield
        releaseId={releaseId}
        field={ReleaseSongFieldType.SongRemixers}
      />
      <AdvancedOptionsTextfield
        releaseId={releaseId}
        field={ReleaseSongFieldType.SongProducers}
      />
    </Stack>
  );
};

export default AdvancedOptions;
